module.exports = __webpack_public_path__ + "img/jigsaw-option-3.72b7c72a.png";